import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <React.Fragment>
      <div
        className="px-[20px] font-serif mt-[50px] lg:mt-[150px] lg:px-[100px]"
        id="about"
      >
        <h1 className="text-center text-[#E84949] p-4 text-2xl font-bold">
          About
        </h1>
        <div
          data-aos="fade-right"
          className="flex justify-between items-center mt-4 lg:mt-[40px] lg:gap-[20px]"
        >
          <img
            className="hidden lg:flex h-[300px] w-[800px]"
            src="/Idris.jpeg"
            alt="AboutImage"
          />
          <p data-aos="zoom-in-up" className="text-center">
            Idris Haruna Alih is a frontend developer, he is proficient in HTML,
            CSS, Tailwind CSS, JavaScript, ReactJS, GIT and GITHUB. He is a
            graduate of Federal University Of Technology, Minna from the
            department of Geology. currently, he is making a research on how a
            software can enhance the best fragmentation in quarry blasting in
            the mining sector. Haruna is well trained and a certified peace
            ambassador by actionAid Nigeria. A true team player with strengths
            in adaptability and accuracy. A lover of chess game, football, and
            have interest in AI, Robotics, and Education.
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default About;
